// extracted by mini-css-extract-plugin
export var container = "why-nftfi-module--container--f1ce1";
export var image = "why-nftfi-module--image--2718e";
export var intro = "why-nftfi-module--intro--0760d";
export var item = "why-nftfi-module--item--fc39e";
export var items = "why-nftfi-module--items--7671a";
export var section = "why-nftfi-module--section--2fad4";